import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import UserContext from 'contexts/UserContext';

import TestDate from 'components/Form/TestDate';
import Icon from 'components/Icon';

const Course = ({ index, gradeId, course }) => {
	// Use user's context
	const { handleUser } = useContext(UserContext);

	// Handle student's course change
	// @event: object | native onChange event
	const onChange = event => {
		const { name, value } = event.target || event;
		handleUser({
			type: 'ON_CHANGE_COURSE_STUDENT',
			payload: {
				gradeId,
				id: course.id,
				name,
				value
			}
		});
	};

	// Handle student's course change
	// @event: object | native onChange event
	const onChangeExam = event => {
		const { name, value } = event.target || event;
		handleUser({
			type: 'ON_CHANGE_EXAM_STUDENT',
			payload: {
				gradeId,
				id: course.id,
				name,
				value
			}
		});
	};

	// Handle student's course removal
	const onRemove = () => {
		handleUser({
			type: 'ON_REMOVE_COURSE_STUDENT',
			payload: {
				gradeId,
				id: course.id
			}
		});
	};

	return (
		<div className="course">
			<Link to={`/courses/${course.id}`} className="course__title">
				{course.title}
				<br />
				<small>{course.subject.title}</small>
			</Link>

			<TestDate
				name="startDate"
				value={course.startDate}
				onChange={onChange}
			/>

			<div className="exam">
				<Link to={`/exams/${course.exam.id}`} className="exam__title" >{course.exam.title}</Link>
				<div className="exam__dates">
					<TestDate
						name="startDate"
						value={course.exam.startDate}
						onChange={onChangeExam}
					/>

					<div className="exam__divider">•</div>

					<TestDate
						end
						name="endDate"
						value={course.exam.endDate}
						onChange={onChangeExam}
					/>
				</div>
			</div>

			<Icon
				icon="close"
				size="md"
				className="course__remove"
				onClick={onRemove}
			/>
		</div>
	);
};

export default Course;